/***
 *
 *   INPUT STYLES
 *   Ported from ui-reference/src/components/ui/{input,textarea}.tsx.
 *
 *   h-10, rounded-md, a hairline on `border-input`, and a 2px focus ring on
 *   `--ring`. The previous fields were rounded-2xl with no focus ring and a
 *   background change on focus.
 *
 **********/

const Style = {
    input: 'relative mb-4 space-y-1.5 last:mb-0',

    textbox: `flex h-10 w-full rounded-md border border-input bg-surface px-3 py-2 text-sm text-text-primary
    shadow-sm transition-colors placeholder:text-text-muted focus-visible:outline-none focus-visible:ring-2
    focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50`,

    // Multi-line variant — the reference's Textarea.
    textarea: `min-h-[92px] w-full rounded-md border border-input bg-surface px-3 py-2 text-sm text-text-primary
    shadow-sm transition-colors placeholder:text-text-muted focus-visible:outline-none focus-visible:ring-2
    focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50`,

    cardbox: '!h-auto !p-3',

    // Validation states tint the border only. The old error style filled the
    // field with red at 20% and recoloured the placeholder, which fought the
    // error message sitting right under it.
    success: 'border-success focus-visible:ring-success/40',
    error: 'border-error focus-visible:ring-error/40',
    warning: 'border-warning focus-visible:ring-warning/40',

    /* Wrapper the field + its validity affordance share. The check used to be
       positioned against `input` (the whole block) at a hard-coded
       `top-[2.35rem]`, i.e. label height + half a field — so it only landed
       centred on a labelled single-line field, and drifted off-centre on every
       unlabelled one, on a two-line label, and on a textarea. Anchoring to the
       control itself makes `top-1/2` exact in all of those. */
    field: 'relative',

    successIcon: 'pointer-events-none absolute right-3 top-1/2 z-10 -translate-y-1/2 text-success',

    // Textarea grows downwards, so centring on it would drop the check into the
    // middle of the text. Pin it to the first line instead.
    successIconTextarea: 'pointer-events-none absolute right-3 top-3 z-10 text-success',

    // textList keeps its own inset: that field has a trailing add button the
    // check would otherwise sit under.
    successIconTextList: 'pointer-events-none absolute right-12 top-1/2 z-10 -translate-y-1/2 text-success',
};

export default Style;
